namespace Areas.RequestAccess {
    "use strict";

    export function saveForm(url: string, data: any) {
        const errorMessage = "Error in request - Contact IS department";

        $.ajax({
            url: url,
            method: "POST",
            contentType: "application/json",
            data: JSON.stringify(data),
            success: (response) => {
                if (response.errormsg) {
                    DevExpress.ui.notify(response.errormsg, "error", 2000);
                } else {
                    $('#step1').hide();
                    $('#step1a').hide();
                    $('#step2').show();
                }
            },
            error: (response) => {
                DevExpress.ui.notify(response.responseText, "error", 2000);
            }
        });
    }
}
